module.exports = __webpack_public_path__ + "static/img/tax_saas_bg.bfa85b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/h5/matrix/tax_saas_bg.png
// module id = txdl
// module chunks = 34